module.exports = __webpack_public_path__ + "img/add-blue-24dp.22e5db49.svg";